var map = {
	"./Dummy.address.js": 8898,
	"./DummyTickets.address.js": 3913,
	"./FakeCheez.address.js": 6073,
	"./FakeDAI.address.js": 5378,
	"./Fondue.address.js": 8471,
	"./FonduePot.address.js": 6473,
	"./FondueTickets.address.js": 6922,
	"./FondueTicketsV2.address.js": 1636,
	"./Jackpot.address.js": 1463,
	"./Test1155.address.js": 7678,
	"./TheFondueMicePot.address.js": 7257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8410;